(function ($) {
    let slideTos = $('.slide-to');
    if (slideTos) {
        slideTos.each(function () {
            let to = $(this);
            to.on('click', function (event) {
                let target = $(this).data('target');
                event.preventDefault();
                if (target) {
                    jQuery('html, body').animate({
                        scrollTop: (jQuery(target).offset().top - 130)
                    }, 300);
                }
            });
        });
    }
})(jQuery);
